import { useSelector } from 'react-redux';
import { selectReportSummaryEntitiesIsOpen } from '../../selectors';

export const useEntitySectionIsOpen = (): boolean => {
  const selectEntitySectionIsOpen = useSelector(selectReportSummaryEntitiesIsOpen);

  return selectEntitySectionIsOpen;
};
